import '../assets/css/index.css'
// import 'bootstrap/dist/css/bootstrap.min.css'

import React from 'react'
// import { ContainedApp } from './appContainer'
import { AppContainer } from './revised_components/appContainer'
// import { GalleryWindowedContainer } from './galleryWindowedContainer'
// import { LanguageEditorWindowedContainer } from './languageEditorWindowedContainer'
import { MemoryRouter as Router } from 'react-router-dom'
// TODO: implement this: import { BrowserRouter  as Router } from 'react-router-dom'

// import { fastGetLocal, fastSetLocal } from '../services/storage'

// class _App extends Component {

//   componentDidMount() {
//     fastSetLocal('popoutId', null)
//   }

//   render() {
//     let str = window.location.href
//     let type = str.substring(str.lastIndexOf('?'), str.lastIndexOf('='))
//     let content = null
//     let galId = fastGetLocal('popoutId')
//     let id = window.location.search.split('=')[1]
//     if (galId) {
//       type = '?gal'
//       if (galId === 'lang') type = '?lang'
//       id = galId
//     }
//     if (type === '?gal') {
//       content = (

//         <GalleryWindowedContainer id={id} />

//       )
//     } else if (type === '?lang') {
//       content = <LanguageEditorWindowedContainer />

//     } else {
//       content = (
//         <Router>
//           <AppContainer />
//         </Router>
//       )
//     }
//     return content
//   }
// }
// const ipc = window.require('electron').ipcRenderer
// let key_maybe
// ipc.on('receive-key', (e, arg)=> {
//   key_maybe = arg
//   console.log('setttingnging', key_maybe)
// })

export default function App() {

  // let comp = useMemo(() => {
    // if(!key_maybe) return []
    // console.log('new app', window.location)
    // let str = window.location.href
    // let type = str.substring(str.lastIndexOf('?'), str.lastIndexOf('='))
    let content = null
    // let galId = fastGetLocal('popoutId')
    // let id = window.location.search.split('=')[1]
    
      content = (
        <Router>
          <AppContainer />
        </Router>
      )
    
    return content
  // })
  // return comp
}
